export enum ProjectAdministratorTypes {
    ProspectManager = 1,
    ProjectCoordinator,
    CrewChief,
    ClientLandman,
}

export default class ProjectAdministrationType {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/ProjectAdministrationType.ts